import { z } from 'zod';
export const errorCodeSchema = z.enum([
    'VALIDATION_ERROR',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'CHILD_NOT_FOUND',
    'ASSET_NOT_FOUND',
    'QUEST_NOT_FOUND',
    'CONFLICT',
    'PAYLOAD_TOO_LARGE',
    'UNSUPPORTED_MEDIA_TYPE',
    'RATE_LIMITED',
    'NOT_FOUND',
    'INTERNAL_ERROR',
]);
export const apiErrorBodySchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        message: z.string(),
        requestId: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=errors.js.map